<template>
  <div class>
    <van-list :finished="true"
              finished-text="没有更多了">
      <van-cell v-for="(item, index) in list"
                :key="index"
                @click="choose(item)">
        <template #title>
          <span class="custom-title">{{ item.NAME }}</span>
          {{ item.DEPT_DESCR }}
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
 
<script>
export default {
  props: ['list'],
  methods: {
    choose(item) {
      this.$emit('chooseItem', item)
    },
  },
}
</script>
 
<style lang = "less" scoped>
</style>